
<div *ngIf="isMobile; else webLogin" class="full-container">
  <div class="edit-container">
    <div class="top-content">
      <div class="bid-info-mobile">
        <div class="instruction-mobile">Notifications</div>
      </div>

      <div class="table-container-mobile" *ngIf="notifications.length > 0">
        <table>
          <thead></thead>
          <tbody class="table-body-mobile">
            <tr *ngFor="let notification of notifications">
              <td class="notification-item-mobile" (click)="handleNotificationClick(notification)">
                {{ notification.message }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-container-mobile notification-item-mobile" *ngIf="notifications.length === 0">
        No notifications available.
      </div>
    </div>

    <div class="bottom-content">
      <div class="cancel-and-submit-buttons">
        <div class="cancel-button-mobile">
          <button type="button" (click)="onCancel()">Cancel</button>
        </div>
        <div class="submit-button-mobile">
          <button type="button" (click)="clearNotifications()">Clear Notifications</button>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #webLogin>
  <div class="notification-container">
    <div class="form-container">
      <div class="form-header">Notifications</div>

      <div class="table-container" *ngIf="notifications.length > 0">
        <table>
          <tbody>
            <tr *ngFor="let notification of notifications; let i = index">
              <td class="notification-item" (click)="handleNotificationClick(notification)">
                <div class="notification-main">
                
                  <div class="notification-message">
                    {{ notification.message }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-container" *ngIf="notifications.length === 0">No notifications available.</div>

      <div>
        <div class="form-actions">
          <button type="button" (click)="onCancel()">Cancel</button>
          <button type="button" (click)="clearNotifications()">Clear Notifications</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
